import "./ContactFormPrivacyNotice.module.css";
import Header from "@/reusable_sections/Header";
import Disclosure from "./sections/Disclosure";
import Footer from "@/reusable_sections/Footer";
export default function ContactFormPrivacyNoticePage() {
  return <div>
      <Header />
      <Disclosure />
      <Footer />
    </div>;
}